import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { InformationPageService } from 'src/app/services/informationPage.service';

@Component({
  selector: 'app-song-suggestion',
  templateUrl: './song-suggestion.component.html',
  styleUrls: ['./song-suggestion.component.scss']
})
export class SongSuggestionComponent implements OnInit {
  public songForm: FormGroup;
  loading = false;
  public isResolveCaptcha = false;
  @ViewChild('captchaRef') captchaRef: any;

  constructor(private fb: FormBuilder, private pageService: InformationPageService, private alertService: HttpAlertService) { }

  ngOnInit(): void {
    this.songForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      url: [null],
      captcha: [null, [Validators.required]]
    });
  }

  resolved(captchaResponse: string) {
    //this.isResolveCaptcha = true;
    this.songForm.get('captcha').setValue(captchaResponse);
  }

  submitForm() {
    if (this.songForm.valid) {
      this.loading = true;
      this.pageService.suggestForm(this.songForm.value).subscribe({
        next: (r) => {
          this.songForm.reset();
          this.alertService.success("suggest_has_sent");
          this.captchaRef.reset();
        },
        complete: () => {
          this.loading = false;
        }
      });
    }

  }

}
